import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'
import About from './component/about';
import Contact from './component/Contact';
import Heading from './component/Heading';
import Section from './component/blogs_section';
import Main from './component/main';
import logo from './logo.png'
import Blog from './component/web_blogs.js/backend-of-website';
import Mern from './component/web_blogs.js/mern-stack';
import Success from './component/web_blogs.js/success';
import Fullstack from './component/web_blogs.js/fullstack';
import Map from './component/web_blogs.js/map';
import Css from './component/web_blogs.js/css';
function App() {
  return (
    <>
      <Router>
        <nav>
          <div className="logo">
            <img src={logo} alt="" />
            <h1>Web</h1>
          </div>
          <ul className='ul'>
            <li className='li'><Link to="/" style={{ color: "white", textDecoration: "none" }}>Home</Link></li>
            <li className='li'><Link to="/about" style={{ color: "white", textDecoration: "none" }}>About</Link></li>
            <li className='li'><Link to="contacts.js" style={{ color: "white", textDecoration: "none" }}>Contact</Link></li>
          </ul>
        </nav>
        <div className="">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/about" element={<About />} />
            <Route path='/contacts.js' element={<Contact />} />
            <Route path='/backend-of-website.js' element={<Blog />} />
            <Route path='/mern-stack.js' element={<Mern/>} />
            <Route path='/full_stack' element={<Fullstack/>} />
            <Route path='/map-filter-reduce' element={<Map/>} />
            <Route path='/css' element={<Css/>} />
          </Routes>
        </div>
      </Router>
    </>
  )
}
export default App;